import toast from './toast.vue';

export default {
    install(Vue) {
        const Constructor = Vue.extend(toast);
        const instance = new Constructor();
        instance.$mount(document.createElement('div'));
        document.body.appendChild(instance.$el);

        Vue.prototype.$toast = ({
            title,
            icon = '',
            duration = 2000,
            mask,
            error,
        }) => {
            if (icon === 'success') {
                instance.icon = 'checked';
            } else {
                instance.icon = '';
            }
            instance.message = title;
            instance.show = true;

            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    instance.show = false;
                    resolve();
                }, duration);
            });
        };
    },
};
